/**
 * Button component for handling reservation actions
 * @element mx-order-button
 */
class OrderButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.handleEvent);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleEvent);
  }

  /**
   * When the user clicks a button this sets the state to the selected location
   */
  handleEvent() {
    // event.preventDefault();
    // event.stopPropagation();
    this.state.selectedOrderId.value = this.getAttribute("id");
  }

  /**
   * Subscribes this component to the app state
   * @param {ReturnType<import("src/services/state").createAppState>} state
   * @example
   * const state = signal(42);
   * const el = document.querySelector('mx-reserve-button');
   * el.subscribe(state)
   */
  subscribe(state) {
    if (!this.state) {
      this.state = state;
    }
  }
}

customElements.define("mx-order-button", OrderButton);
